import { render, staticRenderFns } from "./TypeTable.vue?vue&type=template&id=54c49443&scoped=true&"
import script from "./TypeTable.vue?vue&type=script&lang=js&"
export * from "./TypeTable.vue?vue&type=script&lang=js&"
import style0 from "./TypeTable.vue?vue&type=style&index=0&id=54c49443&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c49443",
  null
  
)

export default component.exports